import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'cv-circular-progress-bar',
  standalone: true,
  template: `
    <div class="circle-wrapper">
      <svg viewBox="0 0 36 36" class="circular-chart">
        <path class="circle-bg" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
        <path
          class="circle"
          [attr.stroke]="color"
          [attr.stroke-dasharray]="value"
          d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
        />
      </svg>
      <div class="circle-inner-content">
        <ng-content></ng-content>
      </div>
    </div>
  `,
  styleUrl: './circular-progress-bar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CircularProgressBarComponent {
  @Input({ transform: getDashArray }) value: number = 0;
  @Input() color: string = '';
}

function getDashArray(filledPercentage: number): string {
  const circumference = 100;
  return `${filledPercentage} ${circumference - filledPercentage}`;
}
